import React from 'react'

import { BrowserRouter } from 'react-router-dom'

export const ReactRouterProvider = ({
    children,
}: React.PropsWithChildren<{}>) => {
    return <BrowserRouter>{children}</BrowserRouter>
}
